// extracted by mini-css-extract-plugin
export default {"cls1":"qqFI72OlaYkovaHod_QX","cls2":"TduGubKck3RjU5UKaSvQ qqFI72OlaYkovaHod_QX","isPhone":"zxWoZhUPT0RiiSZSaJeQ","bookingAppRedesign":"pbLWzKE7cmuaNOFLJvhD"};